// First-touch UTM / Google Ads attribution capture.
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid"];
const STORAGE_KEY = "da_attribution";

export function captureUtm() {
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) found[k] = v;
    });
    // A gclid alone means the visitor came from a Google Ads click
    if (found.gclid && !found.utm_source) {
      found.utm_source = "google";
      found.utm_medium = found.utm_medium || "cpc";
    }
    if (Object.keys(found).length === 0) return;
    const existing = getUtm();
    if (existing && (existing.utm_source || existing.gclid)) return; // keep first-touch
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        ...found,
        landing_page: window.location.pathname,
        referrer: document.referrer || "",
        captured_at: new Date().toISOString(),
      })
    );
  } catch (e) {
    /* ignore */
  }
}

export function getUtm() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}
